import { FEATURE_FLAGS } from "./";
import type { FeatureFlagsValue } from "./types";

export const DEFAULT_FEATURE_FLAGS_VALUES = Object.fromEntries(
	Object.entries(FEATURE_FLAGS).map(([key, flag]) => [key, flag.defaultValue]),
) as FeatureFlagsValue;
